import React from 'react'
import Icons from '~storybook/icons/index'
import NavLink from '~utils/navlink'

export const SocialShare = ({ enabled, url }) => {
  return (
    <div className="flex flex-row">
      {Array.isArray(enabled) && enabled.includes('linkedin') && (
        <div className="mr-1">
          <NavLink to={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`}>
            <Icons.LinkedIn />
          </NavLink>
        </div>
      )}
      {Array.isArray(enabled) && enabled.includes('facebook') && (
        <div className="mr-1">
          <NavLink to={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`}>
            <Icons.Facebook />
          </NavLink>
        </div>
      )}
      {Array.isArray(enabled) && enabled.includes('twitter') && (
        <div className="mr-1">
          <NavLink to={`http://www.twitter.com/share?url=${encodeURIComponent(url)}`}>
            <Icons.Twitter />
          </NavLink>
        </div>
      )}
    </div>
  )
}

export default SocialShare
